import React, {useCallback} from 'react';
import {Dialog} from '@priority-software/priority-style-react';
import {formsStore} from '../../stores/Form/FormsStore';
import styles from './style.module.scss';
import {MainPage} from '../../_shared/Help/components/FormHelpPages/MainPage';
import {ListPage} from '../../_shared/Help/components/FormHelpPages/ListPage';
import {DetailsPage} from '../../_shared/Help/components/FormHelpPages/DetailsPage';
import {FormHelp, FormHelpPageState, Pages} from '../../_shared/Help/types';
import usePortal from 'react-useportal';
import {observer} from 'mobx-react';
import {getTopDialogZindex} from '../../_shared/GWTBridge/invoke/priModalDlg';

export type Props = {
    helpPageQueue: FormHelpPageState[];
    onClose: () => void;
    title: string;
    isLoadingHelpData: boolean;
    addHelpPage: (page: FormHelpPageState) => void;
    setHelpPageQuery: (query: string) => void;
    setHelpActiveListPage: (pageNumber: number) => void;
    formHelp: FormHelp;
    removeHelpPage: () => void;
    showHelp: boolean;
    zIndex?: number;
};
export const HelpBook = observer(
    ({
        helpPageQueue,
        onClose,
        title,
        isLoadingHelpData,
        addHelpPage,
        setHelpPageQuery,
        setHelpActiveListPage,
        removeHelpPage,
        formHelp,
        showHelp,
        zIndex = getTopDialogZindex()
    }: Props) => {
        const {Portal} = usePortal();

        const renderContent = useCallback(() => {
            const {
                id,
                page,
                docType,
                activePage = 1,
                query = ''
            } = helpPageQueue[helpPageQueue.length - 1];

            switch (page) {
                case Pages.main:
                    return (
                        <MainPage
                            isLoadingHelpData={isLoadingHelpData}
                            addHelpPage={addHelpPage}
                            setHelpPageQuery={setHelpPageQuery}
                            title={title}
                            isNewApi={!formsStore?.currentForm}
                            query={query}
                            formHelp={formHelp}
                        />
                    );
                case Pages.list:
                    return (
                        <ListPage
                            docType={docType}
                            activePage={activePage}
                            query={query}
                            title={title}
                            formHelp={formHelp}
                            setHelpActiveListPage={setHelpActiveListPage}
                            setHelpPageQuery={setHelpPageQuery}
                            removeHelpPage={removeHelpPage}
                            addHelpPage={addHelpPage}
                        />
                    );
                case Pages.details:
                    return <DetailsPage id={id} removeHelpPage={removeHelpPage} />;
                default:
                    return null;
            }
        }, [helpPageQueue, formHelp, isLoadingHelpData, title]);

        return (
            <Portal>
                <div className="reactComp">
                    {showHelp && zIndex >= 0 ? (
                        <Dialog
                            isOpen={showHelp}
                            content={renderContent()}
                            componentClasses={styles.formHelpDialg}
                            onClose={onClose}
                            mask={false}
                            size="large"
                            draggable
                            zIndex={zIndex}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </Portal>
        );
    }
);
